import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import "./index.css";

const PasswordValidator = ({
  password,
  user,
  firstName,
  lastName,
  emailAddress,
  passwordComponentType,
  gaOktaEnabled
}) => {
  // Rule: 0. Must be 8 - 50 character long
  // Rule: 1. Must contain at least one upper case and one lower case letter
  // Rule: 2. Must have at least one number or special character
  // Rule: 3. Cannot have more than two consecutive of the same characters
  // Rule: 4. Does not contain your first name, last name, User ID, or email address
  // Rule for okta => One special charatcer and one number, both are required
  const atLeastOneCap = /[A-Z]+/;
  const atLeastOneLower = /[a-z]+/;
  const notAlpha = /[0-9!@?]+/;
  const atLeastOneNumber = /[0-9]+/;
  // eslint-disable-next-line no-useless-escape
  const atLeastOneNumSpecialChar = /[!@#$%^&:;,.*()_+={}\\|\[\]?~-]+/;
  const moreThanTwoReps = /(.)\1\1/;
  const illegalChar = /[<>/'"]/;
  const containsIllegalChars = illegalChar.test(password);
  const value = password;

  const passwordsuggestion = (object) =>
    object.value === true ? "Met" : "Not Met";

    const passwordRules = [
      {
        key: 0,
        value: value.length >= 8 && value.length <= 50,
        errormessage: "At least 8 characters but no more than 50.",
      },
      {
        key: 1,
        value: atLeastOneCap.test(value) && atLeastOneLower.test(value),
        errormessage: "At least one upper case and one lower case letter.",
      },
      {
        key: 2,
        value: notAlpha.test(value) && !containsIllegalChars,
        errormessage: `At least one number or special character. Not allowed : < > / ‘ “`,
      },
      {
        key: 3,
        value: !moreThanTwoReps.test(value),
        errormessage: "No character is used more than twice in a row.",
      },
      {
        key: 4,
        value:
          value?.toLowerCase()?.indexOf(user?.toLowerCase()) === -1 &&
          value?.toLowerCase()?.indexOf(firstName?.toLowerCase()) === -1 &&
          value?.toLowerCase()?.indexOf(lastName?.toLowerCase()) === -1 &&
          value?.toLowerCase()?.indexOf(emailAddress?.toLowerCase()) === -1,
        errormessage:
          "Does not contain your first name, last name, User ID, or email address.",
      },
    ];

  const passwordRulesOkta = [
    {
      key: 0,
      value: value.length >= 8 && value.length <= 50,
      errormessage: "At least 8 characters but no more than 50.",
    },
    {
      key: 1,
      value: atLeastOneCap.test(value) && atLeastOneLower.test(value),
      errormessage: "At least one upper case and one lower case letter.",
    },
    {
      key: 2,
      value: atLeastOneNumber.test(value) && !containsIllegalChars,
      errormessage: `At least one number`,
    },
    {
      key: 3,
      value: atLeastOneNumSpecialChar.test(value) && !containsIllegalChars,
      errormessage: `At least one special character. Not allowed : < > / ‘ “`,
    },
    {
      key: 4,
      value: !moreThanTwoReps.test(value),
      errormessage: "No character is used more than twice in a row.",
    },
    {
      key: 5,
      value:
        value?.toLowerCase()?.indexOf(user?.toLowerCase()) === -1 &&
        value?.toLowerCase()?.indexOf(firstName?.toLowerCase()) === -1 &&
        value?.toLowerCase()?.indexOf(lastName?.toLowerCase()) === -1 &&
        value?.toLowerCase()?.indexOf(emailAddress?.toLowerCase()) === -1,
      errormessage:
        "Does not contain your first name, last name, User ID, or email address.",
    },
  ];

  const validatorRules = gaOktaEnabled === 'Y' ? passwordRulesOkta : passwordRules;
  const passwordMessages = validatorRules.map((object) => (
    <div key={object.key} className="password-container">
      <div
        className={`${
          passwordComponentType === "planholder" ? "mr-2" : "icon"
        }`}
      >
        {object.value === true ? (
          <FontAwesomeIcon
            icon={faCheckCircle}
            className={`success-icon ${
              passwordComponentType === "planholder" && "plan-holder-icon"
            }`}
            aria-hidden="false"
          />
        ) : (
          <FontAwesomeIcon
            icon={faCheckCircle}
            className={`failure-icon ${
              passwordComponentType === "planholder" && "plan-holder-icon"
            }`}
            aria-hidden="false"
          />
        )}
      </div>
      <div className="content">
        <div
          role="alert"
          data-testid="passwordError"
          aria-label={`${passwordsuggestion(object)} ${object.errormessage}`}
          className={`${
            object.value === true ? "black-color-text" : "gray-color-text"
          }`}
        >
          {object.errormessage}
        </div>
      </div>
    </div>
  ));

  return <div className="password-validator">{passwordMessages}</div>;
};

PasswordValidator.propTypes = {
  user: PropTypes.string,
  password: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  emailAddress: PropTypes.string,
  passwordComponentType: PropTypes.string,
  gaOktaEnabled: PropTypes.string,
};

export default PasswordValidator;
